import Header from '@components/Header';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import InquiryLogs from './components/InquiryLogs';
import InquiryTabHeader from './components/InquiryTabHeader';
import InquiryWriteForm from './components/InquiryWriteForm';

interface Params {
    type: 'READ' | 'WRITE';
}

const InquiryActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('inquiry');
    const { type } = params;
    const { stepReplace } = useStepFlow('InquiryActivity');
    return (
        <AppScreen>
            <Header title={t('header.title')} />
            <InquiryTabHeader type={type} />
            {type === 'WRITE' && (<InquiryWriteForm/>)}
            {type === 'READ' && (<InquiryLogs/>)}
        </AppScreen>
    );
};

export default InquiryActivity;
